import Col from '~/grid/Col';
import Row from '~/grid/Row';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @returns {React.ReactElement} The rendered component
 */
const ExtendedGridWrapper = ({ children }) => {
  return (
    <Row>
      <Col
        colAmount={{
          xl: 10,
          lg: 10,
          md: 12,
          sm: 12,
          xs: 12,
        }}
      >
        {children}
      </Col>
    </Row>
  );
};

export default ExtendedGridWrapper;
